import { StorageUnitSizeFragment } from 'types/generated/graphql';

export const formatStorageUnitSize = (
  storageUnitSize?: StorageUnitSizeFragment | null
): string => {
  if (!storageUnitSize || storageUnitSize.isServiceModule) {
    return '';
  }

  return storageUnitSize.friendlyName || '';
};
